<template>
  <div>
    <Table
      :columns="columns"
      :data="formattedEntities"
      :isUpdatable="true"
      :isAccessible="true"
      @update="(row) => (editingEntity = row)"
      @view="viewEntity"
    >
      <template #storeNames="{ row }">
        <span class="flex flex-wrap gap-x-2 text-sm text-gray-700" :title="row.storeNamesFull">
          <TableLink
            v-for="store in row.visibleStores"
            :key="store.id"
            :to="`/stores/${store.id}`"
            data-test="store-link"
          >
            {{ store.salesChannel }}
          </TableLink>
          <span v-if="row.remainingStoresCount > 0">(+{{ row.remainingStoresCount }})</span>
        </span>
      </template>
    </Table>
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="fetchEntities"
    />
    <Modal v-if="editingEntity" :open="true" @close="editingEntity = null">
      <BillingEntityFormEdit :billingEntity="editingOriginalEntity" :stores="stores" @success="entityUpdated" />
    </Modal>
  </div>
</template>

<script>
import { Table, Pagination, Modal, TableLink } from "@estaly/ui";
import BillingEntityFormEdit from "@/components/billing_entities/BillingEntityFormEdit.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Table,
    Pagination,
    Modal,
    BillingEntityFormEdit,
    TableLink,
  },
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    stores: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editingEntity: null,
      storeNamesLimit: 3,
      columns: [
        { label: "ID", field: "id" },
        { label: "Nom", field: "name" },
        { label: "Raison sociale", field: "businessName" },
        { label: "Adresse", field: "billingAddress" },
        { label: "Magasins", field: "storeNames", slot: "storeNames" },
      ],
    };
  },
  computed: {
    ...mapState("billingEntities", ["billingEntities", "currentPage", "totalPages", "totalCount"]),
    formattedEntities() {
      return this.billingEntities.map((entity) => {
        const stores = entity.stores?.filter((s) => s.salesChannel) || [];
        const visibleStores = stores.slice(0, this.storeNamesLimit);
        return {
          ...entity,
          visibleStores,
          remainingStoresCount: stores.length - visibleStores.length,
          storeNamesFull: stores.map((s) => s.salesChannel).join(", "),
        };
      });
    },
    editingOriginalEntity() {
      return this.billingEntities.find((e) => e.id === this.editingEntity?.id);
    },
  },
  mounted() {
    this.fetchEntities();
  },
  methods: {
    ...mapActions("billingEntities", ["fetchIndex"]),
    fetchEntities(page = 1) {
      this.fetchIndex({ organizationId: this.organizationId, page });
    },
    viewEntity(row) {
      this.$router.push(`/billing-entities/${row.id}`);
    },
    entityUpdated() {
      this.editingEntity = null;
      this.fetchEntities(this.currentPage);
    },
  },
};
</script>
